import {
  FormErrors,
  FormMapping,
  FormNavigation,
  FormState,
  FormStructure,
  FormValuesConstraint,
  StructureProp,
} from '../types';
import {validateField} from '../utils/validation';

export type ReducerMessage<
  T extends FormValuesConstraint<T>,
  S extends FormStructure<T>,
> =
  | {
      type: 'SET_VALUES_&_VALIDATION';
      payload: {
        values?: Partial<T>;
        validation?: {
          field: keyof T;
          value: boolean;
          structureMapping: FormMapping<T>;
          structure: StructureProp<T, S>;
        };
        errors?: FormErrors<T>;
      };
    }
  | {type: 'SET_NAVIGATION'; payload: FormNavigation<T, S>}
  | {type: 'SET_VALIDATING'; payload: {field: keyof T; value: boolean}}
  | {type: 'SET_ERRORS'; payload: FormErrors<T>}
  | {type: 'SET_SUBMITTING'; payload: boolean};

// State reducer
export default function formReducer<
  T extends FormValuesConstraint<T>,
  S extends FormStructure<T>,
>(state: FormState<T, S>, msg: ReducerMessage<T, S>): FormState<T, S> {
  const newValidation = structuredClone(state.validation);

  switch (msg.type) {
    case 'SET_VALUES_&_VALIDATION':
      if (msg.payload.validation) {
        validateField(
          msg.payload.validation.field,
          msg.payload.validation.value,
          newValidation,
          msg.payload.validation.structureMapping,
          msg.payload.validation.structure,
        );
      }

      return {
        ...state,
        values: {
          ...state.values,
          ...msg.payload.values,
        },
        validation: newValidation,
        errors: {
          ...state.errors,
          ...msg.payload.errors,
        },
      };
    case 'SET_NAVIGATION':
      return {
        ...state,
        navigation: msg.payload,
      };
    case 'SET_VALIDATING':
      return {
        ...state,
        validating: {
          ...state.validating,
          [msg.payload.field]: msg.payload.value,
        },
      };
    case 'SET_ERRORS':
      return {
        ...state,
        errors: {
          ...state.errors,
          ...msg.payload,
        },
      };
    case 'SET_SUBMITTING':
      return {
        ...state,
        isSubmitting: msg.payload,
      };
    default:
      return state;
  }
}
